// assets/wishlist-groepsmodus.js
//
// Sitebreed script (geladen via theme.liquid, dus op elke pagina actief).
// Regelt:
//   1. Detecteert ?voor_lijst=CODE in de URL en onthoudt dat in localStorage,
//      MET een vervaltijd (24 uur) — zodat groepsmodus niet voor altijd
//      "aan" blijft staan als iemand vergeet op "Stoppen" te klikken.
//   2. Toont een banner zolang iemand actief in groepsmodus zit
//   3. Maakt de "Voeg toe aan groepslijst"-knop dynamisch aan — precies één
//      keer, direct naast het eerste hartje op een festivalpagina.

(function () {
  var GROEP_KEY = "fz_voor_lijst";
  var GELDIGHEIDSDUUR_MS = 24 * 60 * 60 * 1000; // 24 uur

  function huidigeShareCode() {
    var ruw = localStorage.getItem(GROEP_KEY);
    if (!ruw) return null;
    try {
      var data = JSON.parse(ruw);
      if (!data.code || !data.verlooptOp) return null;
      if (Date.now() > data.verlooptOp) {
        // Verlopen — automatisch opruimen, geen actie meer tonen.
        localStorage.removeItem(GROEP_KEY);
        return null;
      }
      return data.code;
    } catch (e) {
      // Oud, ongeldig formaat (bv. van vóór deze update) — opruimen.
      localStorage.removeItem(GROEP_KEY);
      return null;
    }
  }

  function zetGroepsmodus(code) {
    localStorage.setItem(
      GROEP_KEY,
      JSON.stringify({ code: code, verlooptOp: Date.now() + GELDIGHEIDSDUUR_MS })
    );
  }

  // Stap 1 — URL-parameter overnemen, MET verlooptijdstip, en de URL zelf
  // weer opschonen.
  var params = new URLSearchParams(window.location.search);
  var uitUrl = params.get("voor_lijst");
  if (uitUrl) {
    zetGroepsmodus(uitUrl);
    params.delete("voor_lijst");
    var nieuweUrl = window.location.pathname + (params.toString() ? "?" + params.toString() : "") + window.location.hash;
    window.history.replaceState({}, "", nieuweUrl);
  }

  document.addEventListener("DOMContentLoaded", function () {
    var shareCode = huidigeShareCode();
    if (!shareCode) return; // geen (geldige) groepsmodus -> niets tonen

    // Stap 2 — banner tonen, met ÉÉN duidelijke knop die zowel de
    // groepsmodus stopt als terugstuurt naar de lijst (in plaats van een
    // verwarrende combinatie van een link + een aparte stopknop).
    var banner = document.createElement("div");
    banner.className = "fz-groepsmodus-banner";
    banner.innerHTML =
      "<span>Je voegt festivals toe aan een gedeelde groepslijst.</span>" +
      "<button id=\"fz-groepsmodus-terug\">Terug naar de lijst</button>";
    document.body.appendChild(banner);

    document.getElementById("fz-groepsmodus-terug").addEventListener("click", function () {
      localStorage.removeItem(GROEP_KEY);
      window.location.href = "/apps/wishlist/share/" + shareCode;
    });

    // De sticky ticketbalk (.fzf-sticky, zie main-festival.liquid) staat
    // ook onderaan het scherm vast — zonder correctie zou onze banner daar
    // overheen vallen op desktop. We meten de hoogte van die balk zodra hij
    // zichtbaar is (klasse "is-visible") en schuiven onze banner er dan
    // precies boven; is de ticketbalk niet zichtbaar, dan zit de banner
    // gewoon onderaan (bottom: 0), zoals op mobiel al vanzelf goed ging.
    function pasBannerPositieAan() {
      var sticky = document.querySelector(".fzf-sticky");
      if (sticky && sticky.classList.contains("is-visible")) {
        banner.style.bottom = sticky.offsetHeight + "px";
      } else {
        banner.style.bottom = "0";
      }
    }

    pasBannerPositieAan();
    window.addEventListener("resize", pasBannerPositieAan);

    var stickyEl = document.querySelector(".fzf-sticky");
    if (stickyEl && window.MutationObserver) {
      new MutationObserver(pasBannerPositieAan).observe(stickyEl, { attributes: true, attributeFilter: ["class"] });
    }

    // Stap 3 — precies één "Voeg toe aan groepslijst"-knop, alleen op
    // festivalpagina's (herkend aan het bestaande hartje).
    var hartje = document.querySelector("[data-fzf-fav]");
    if (!hartje) return;

    var festivalHandle = hartje.getAttribute("data-festival-handle");
    if (!festivalHandle) return;

    var knop = document.createElement("button");
    knop.type = "button";
    knop.className = "fz-add-to-group-btn";
    knop.textContent = "+ Voeg toe aan groepslijst";
    hartje.insertAdjacentElement("afterend", knop);

    knop.addEventListener("click", function () {
      var naamKey = "fz_vote_naam_" + shareCode;
      var naam = localStorage.getItem(naamKey);

      if (!naam) {
        naam = window.prompt("Wat is je naam? (zo weten je vrienden wie dit heeft toegevoegd)");
        if (!naam || !naam.trim()) return;
        naam = naam.trim();
        localStorage.setItem(naamKey, naam);
      }

      knop.disabled = true;
      fetch("/apps/wishlist/add-festival", {
        method: "POST",
        body: new URLSearchParams({ shareCode: shareCode, festivalHandle: festivalHandle, naam: naam }),
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.added) {
            knop.textContent = "✓ Toegevoegd aan groepslijst";
          } else {
            alert(data.error || "Toevoegen mislukt.");
            knop.disabled = false;
          }
        })
        .catch(function (e) {
          console.error("Toevoegen aan groepslijst mislukt:", e);
          knop.disabled = false;
        });
    });
  });
})();
